import { defineNuxtPlugin } from '#app';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

import {
    faArtstation,
    faBehance,
    faDiscord,
    faFacebookF,
    faInstagram,
    faLinkedin,
    faMedium,
    faTelegram,
    faXTwitter,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import {
    faArrowUpRightFromSquare,
    faBagShopping,
    faBooks,
    faCopy,
    faHexagonVerticalNft,
    faHouseUser,
    faPaintbrush,
    faTimes,
    faUserCircle as farUserCircle,
    faUserShakespeare,
} from '@fortawesome/pro-regular-svg-icons';
import {
    faArrowLeft,
    faArrowRight,
    faArrowRightArrowLeft,
    faArrowDown,
    faBadgeCheck,
    faBars,
    faBook,
    faBookOpen,
    faPencilAlt,
    faCheckCircle,
    faChevronLeft,
    faChevronRight,
    faCircle,
    faShoppingBag,
    faClock,
    faCoins,
    faCreditCard,
    faCube,
    faDiceD20,
    faDragon,
    faDownload,
    faEnvelope,
    faExternalLinkAlt,
    faFamily,
    faFile,
    faFingerprint,
    faFireAlt,
    faFlask,
    faGem,
    faGlobePointer,
    faHexagon,
    faHome,
    faImages,
    faMagic,
    faMeh,
    faNetworkWired,
    faNewspaper,
    faPaintBrush,
    faPalette,
    faPallet,
    faPen,
    faRectangleVerticalHistory,
    faRocket,
    faRocketLaunch,
    faScroll,
    faShield,
    faShoppingCart,
    faSignature,
    faSquare,
    faStar,
    faStore,
    faStoreAlt,
    faSwap,
    faTag,
    faThumbsUp,
    faTools,
    faTriangle,
    faTshirt,
    faUser,
    faXmark,
    faUserAstronaut,
    faArrowRightToBracket,
    faArrowRightFromBracket,
    faUsers,
    faLayerGroup,
    faLightbulb,
    faTruckFast,
    faRightToBracket,
    faUserPlus,
    faUserCircle,
} from '@fortawesome/pro-solid-svg-icons';

export default defineNuxtPlugin((nuxtApp) => {
    // Custom icons for auth/account
    library.add(
        faRightToBracket, // sign in
        faUserPlus, // sign up
        faUserCircle, // account
        faArrowRightToBracket,
        faArrowRightFromBracket,
        faLayerGroup,
        faUsers,
        faLightbulb,
        farUserCircle,
        faTruckFast,
        faArrowLeft,
        faArrowUpRightFromSquare,
        faScroll,
        faTshirt,
        faArrowRight,
        faTimes,
        faExternalLinkAlt,
        faBookOpen,
        faArtstation,
        faShoppingBag,
        faUser,
        faPencilAlt,
        faClock,
        faShoppingCart,
        faPaintBrush,
        faDiceD20,
        faFireAlt,
        faCoins,
        faCube,
        faNetworkWired,
        faArrowRight,
        faNewspaper,
        faStar,
        faBagShopping,
        faRocketLaunch,
        faBadgeCheck,
        faLinkedin,
        faGlobePointer,
        faBehance,
        faRocket,
        faFacebookF,
        faHome,
        faXTwitter,
        faFamily,
        faScroll,
        faDiscord,
        faFingerprint,
        faShield,
        faPallet,
        faTimes,
        faHexagonVerticalNft,
        faYoutube,
        faHouseUser,
        faArrowRightArrowLeft,
        faTelegram,
        faMedium,
        faEnvelope,
        faBars,
        faUserAstronaut,
        faFile,
        faDragon,
        faCopy,
        faRectangleVerticalHistory,
        faChevronRight,
        faChevronLeft,
        faPen,
        faBooks,
        faUserShakespeare,
        faInstagram,
        faCircle,
        faPalette,
        faImages,
        faSignature,
        faSquare,
        faHexagon,
        faGem,
        faXmark,
        faTriangle,
        faPaintbrush,
        // New icons for SOL operations
        faDownload,
        faArrowDown,
        faCreditCard,
        faFlask,
        // NFT Marketplace icons
        faStore,
        faStoreAlt,
        faTag,
        faSwap,
        // Additional icons for links
        faBook,
        faMagic,
        // Voting page icons
        faCheckCircle,
        faThumbsUp,
        faMeh,
        faTools,
    );

    nuxtApp.vueApp.component('FontAwesomeIcon', FontAwesomeIcon);
});
